import { get, merge, set } from 'lodash-es';
import { Observable, Subject } from 'rxjs';

// @dynamic
export class DataConfig {
  public static dataModel: any = {};
  public static dataChangeSubject = new Subject<any>();

  public static get onChange(): Observable<any> {
    return DataConfig.dataChangeSubject.asObservable();
  }

  public static set(config: any): void;
  public static set(path: string, value?: any): void;
  public static set(arg1?: any, arg2?: any): void {
    if (arg1 && typeof arg1 == 'string') {
      set(DataConfig.dataModel, arg1, arg2);
      DataConfig.dataChangeSubject.next(DataConfig.dataModel);
    }
    if (arg1 && typeof arg1 == 'object') {
      merge(DataConfig.dataModel, arg1);
      DataConfig.dataChangeSubject.next(DataConfig.dataModel);
    }
  }

  public static get(path: string, defaultValue?: any): any {
    return get(DataConfig.dataModel, path, defaultValue);
  }
}
